/**
 * A function that does nothing and has no return value.
 *
 * Useful because it’s a single place to disable the
 * `@typescript-eslint/no-empty-function` linter rule, instead of repeating it.
 *
 * @note If you find yourself using this in production code
 * (i.e. not in a test or mock context), consider whether it would be
 * more appropriate to allow the function to be `undefined`, and call
 * it as `function?.()`
 */
// eslint-disable-next-line @typescript-eslint/no-empty-function
export function noop(): void {}
